import { ChangeMatchScores as ChangeMatchScoresComponent } from './ChangeMatchScores.component';
import { connector } from './ChangeMatchScores.connector';

export const ChangeMatchScores = connector(ChangeMatchScoresComponent);
